$( document ).ready(function() {
$( ".comparison-toggle" ).on( "change", function() {
    let sizetoggle = $(this).parent().parent().find('.size-toggle option:selected');
    let powertoggle = $(this).parent().parent().find('.power-toggle option:selected');
    let selectedprice = powertoggle.val();
    let selectedpowerval = sizetoggle.val();
    let pricefield = $(this).parent().parent().parent().find('.selected_price');
    let textField = $(this).parent().parent().parent().find('h3');
    let chillingPowerField = $(this).parent().parent().parent().find('.product-details-inner h5');
    let imgField = $(this).parent().parent().parent().find('.product-details img');
    
    let sizeText = sizetoggle.attr('data-size-text');
    let img = sizetoggle.attr('data-image');
    let chillingPower = powertoggle.attr('data-chilling-power');

    textField.html(sizeText);
    chillingPowerField.html(chillingPower);
    imgField.attr('src', img).attr('srcset', img);

    if(selectedprice.includes("standard")) {
        var priceSelection = sizetoggle.attr('data-standard-price');
    }
    else {
        var priceSelection = sizetoggle.attr('data-xl-price');
    }


    if(selectedpowerval.includes("standard")) {
        $(this).closest('.comparsion-section').attr('data-size', 'Standard');
    }
    else {
        $(this).closest('.comparsion-section').attr('data-size', 'XL');
    }


    pricefield.html(`$${new Intl.NumberFormat('en-US').format(priceSelection)}`);

  });


  //Define Defaults for Second Section
    $(".comparsion-section.section-2 .size-toggle option:eq(1)").attr("selected", "selected");
    $(".comparsion-section.section-2 .chillingpower option:eq(1)").attr("selected", "selected");
    $(".comparsion-section.section-2 .chillingpower").trigger( "change" );


});